import { render, staticRenderFns } from "./CompanyUsersTable.vue?vue&type=template&id=0ace6136&scoped=true"
import script from "./CompanyUsersTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanyUsersTable.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CompanyUsersTable.vue?vue&type=style&index=0&id=0ace6136&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ace6136",
  null
  
)

export default component.exports